module.exports = __webpack_public_path__ + "img/2812.69bb7992.jpg";